<template>
    <div class="sbp-psp">
        <h5 class="title body__medium">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Icon">
                    <path id="Vector" d="M8.19843 12.1406L5.39343 13.7579L2.79077 18.2648L13.4077 12.1406H8.19843Z"
                        fill="#AFC6FF" />
                    <path id="Vector_2" d="M16.2124 7.51953L13.4074 9.13679L10.8047 13.6437L21.4177 7.51953H16.2124Z"
                        fill="#DA1844" />
                    <path id="Vector_3"
                        d="M13.4074 5.90144L10.8047 1.39453V10.6343V13.6429V22.8827L13.4074 18.3757V5.90144Z"
                        fill="#F9B229" />
                    <path id="Vector_4" d="M10.8047 1.39453L13.4074 5.90144L16.2124 7.5187H21.4177L10.8047 1.39453Z"
                        fill="#F07F1A" />
                    <path id="Vector_5" d="M10.8047 10.6367V22.8851L13.4074 18.3781V15.1397L10.8047 10.6367Z"
                        fill="#72B22C" />
                    <path id="Vector_6" d="M16.2124 16.7617L13.4074 18.379L10.8047 22.8859L21.4177 16.7617H16.2124Z"
                        fill="#00743E" />
                    <path id="Vector_7" d="M2.79077 6.01562V18.264L5.39343 13.7571V10.5225L2.79077 6.01562Z"
                        fill="#5F5A94" />
                    <path id="Vector_8"
                        d="M10.8051 10.6375V10.6415L2.79077 6.01562L5.39343 10.5225L16.2128 16.7617H21.4181L10.8051 10.6375Z"
                        fill="#0D90CD" />
                </g>
            </svg>
            <span>
                {{ tokens.newDesign.sbpPspTitle }}
            </span>
        </h5>
        <div class="sbp-info">
            <p class="body__medium"><span>1.</span> {{ tokens.newDesign.sbpPspDesc1 }} </p>
            <p class="body__medium"><span>2.</span> {{ tokens.newDesign.sbpPspDesc2 }}</p>
            <div class="wallet">
                <span class="title__large">{{ SbpMethod.wallet || '' }}</span>
                <BaseButtonSmall @click.native="copyAddress(SbpMethod.wallet || '')"
                    :button-text="tokens.newDesign.copy" :icon="'content_copy'" :button-style="'outlined-primary'" />
            </div>
            <p class="body__medium"><span>3.</span> {{ tokens.newDesign.sbpPspDesc3 }} </p>
            <p class="body__medium"><span>4.</span> {{ tokens.newDesign.sbpPspDesc4 }} </p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseButtonSmall from "@/new-design/shared/ui/buttons/BaseButtonSmall.vue"
import { NOTIFICATION } from "@/store/mutations.type"

export default {
    name: "SbpMethod",
    components: { BaseButtonSmall },
    props: {
        method: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        ...mapGetters(['pspList', 'tokens', 'staticBase']),
        SbpMethod() {
            return {
                ...this.pspList.find((i) => i.name === this.method.key),
            }
        },
    },
    methods: {
        copyAddress(wallet) {
            navigator.clipboard.writeText(wallet)
                .then(() => {
                    this.$store.commit(NOTIFICATION, this.newDesign.addressCopied)
                })
                .catch(() => {
                })
        },
    },
}
</script>

<style scoped>
.title {
    color: var(--System-OnSurface);
    padding: 16px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}

.sbp-info {
    padding: 20px 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 4px;
    background: var(--System-Surface1);

    p {
        color: var(--System-OnSurface);
        display: flex;
        gap: 8px;
        text-align: left;

        span {
            color: var(--System-OnSurfaceVariant);
        }
    }
}

.wallet {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--System-Surface5);
    padding-bottom: 8px;

    span {
        overflow: hidden;
        color: var(--System-OnSurface);
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

@media (max-width: 468px) {
    .title {
        text-align: left;
    }
}
</style>
